export const buildRoute = (set, card) => {
	if (!set) {
		return '/sets';
	} else {
		if (!card) {
			return `/sets/${set.id}`;
		}
		return `/sets/${set.id}/${card.id}`;
	}
};
